import { Grid, Box } from '@chakra-ui/react'
import { FC, useCallback, useEffect, useMemo } from 'react'

import useMrpReab from '@hook/mrp/use-reab'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import TwoInfoCard from '@component/Layout/Card/TwoInfo'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'

import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'
const MrpReab: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()

  const {
    loading,
    fetching,
    headers,
    actions,
    tableInteraction,
    data,
    filename,
    getSupplyCommands,
    handleLocalParams,
    params,
    query,
    filters,
    setFilters,
    setFilename,
    setQuery,
    getData,
    dataCards,
    filtersList,
    handleUpdateParams,
    clearAllFilters,
    setReady
  } = useMrpReab()

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          handleLocalParams()
          updateReady()
          data?.length === 0 && getData()
          getSupplyCommands()

          getFilters({
            companies: true,
            worlds: true,
            centers: true,
            providersForDistribution: true,
            categoryManagers: true,
            productManagers: true,
            compactCategories: true,
            categories: true,
            providersForPurchase: true,
            abcCurves: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 291px)'
          : 'calc(100vh - 259px)'
        : hasSessions
        ? 'calc(100vh - 432px)'
        : 'calc(100vh - 400px)',
    [menuToggle, hasSessions]
  )

  const updateReady = useCallback(() => {
    if (data.length === 0 && !loading && !fetching) {
      setReady(true)
    }
  }, [data, setReady, loading, fetching])
  function compararPorCurva(a: any, b: any) {
    if (a.curva < b.curva) {
      return -1
    }
    if (a.curva > b.curva) {
      return 1
    }
    return 0
  }

  return (
    <Layout title="MRP Reab. Emergencial">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <Grid
                templateColumns={`repeat(${
                  dataCards.indicadorCurva.length + 1
                }, 1fr)`}
                gap={4}
                borderBottom="solid 1px"
                borderColor="gray.200"
              >
                <TwoInfoCard
                  title="Total"
                  one={['Produtos', dataCards.produtos]}
                  two={['Peso', dataCards.peso.toFixed(2)]}
                />
                {dataCards?.indicadorCurva?.sort(compararPorCurva).map(item => (
                  <>
                    <TwoInfoCard
                      title={'Curva' + item.curva}
                      one={['Qnt.', item.quantidade > 0 ? item.quantidade : 0]}
                      two={['%', item.percentual > 0 ? item.percentual : 0]}
                    />
                  </>
                ))}
              </Grid>
              <GridQuantity data={data} disabled={data.length === 0} />
              <TableGrid
                id="purschase-table"
                headers={headers}
                query={query}
                data={data}
                loading={fetching}
                actions={tableInteraction}
                height={tableHeight}
                itsSortable={true}
                entity="mrp-reab"
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default MrpReab
